export function getNextPeriod(matchSummary) {
    const index = matchSummary.periods.findIndex(({ code }) => matchSummary.currentPeriod === code);
    return index === -1 ? undefined : matchSummary.periods[index + 1];
}
//# sourceMappingURL=getNextPeriod.js.map